var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Profile---3",
    transform: "translate(-741.000000, -524.000000)",
    fill: "inherit",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(741.000000, 523.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "N_IOTA-Email-Icon-01",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.875,6.75 L12,0.75 C10.875,-0.25 9.25,-0.25 8.125,0.75 L1.125,6.75 C0.375,7.375 0,8.25 0,9.125 L0,18.125 C0,19.125 0.875,20 1.875,20 L18.125,20 C19.125,20 20,19.125 20,18.125 L20,9.125 C20,8.25 19.625,7.375 18.875,6.75 Z M1.25,9.375 L6,13.5 L1.25,17.75 L1.25,9.375 Z M9.875,11.625 C9.875,11.625 10,11.625 10,11.625 L18,18.75 L1.75,18.75 L9.875,11.625 Z M14,13.5 L18.75,9.375 L18.75,17.75 L14,13.5 Z M1.875,7.625 L8.875,1.625 C9.125,1.375 9.625,1.25 10,1.25 C10.375,1.25 10.875,1.375 11.125,1.625 L18.125,7.625 C18.25,7.75 18.375,7.875 18.5,8 L13.125,12.625 L10.875,10.75 C10.375,10.375 9.625,10.375 9.125,10.75 L6.875,12.75 L1.5,8 C1.625,7.875 1.75,7.75 1.875,7.625 C1.875,7.625 1.875,7.625 1.875,7.625 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpen);
export default __webpack_public_path__ + "static/media/envelope-open.8e11ae27e3d61d90ca624b75f450196a.svg";
export { ForwardRef as ReactComponent };